module.exports = __webpack_public_path__ + "images/puzzle/Puzzle/PNG/Piece05.1ca356a1043d2d358dfaf7d09c4a45ad.png";